import {Component, HostBinding, Inject, Injector, OnInit, ViewEncapsulation} from '@angular/core';
import {BaseComponent} from '../../../base.component';
import {DIALOG_DATA, DialogRef} from '@angular/cdk/dialog';
import {animationSlideInOut} from '../../../../util/animation/animation.slideInOut';
import {ListResponse} from '../../../../network/service/list.response';
import {SnackBarUtil} from '../../../../util/snack.bar.util';
import {EditAddressesOptions} from './options/edit-addresses.options';

@Component({
  selector: 'app-edit-addresses',
  standalone: false,
  templateUrl: './edit-addresses.component.html',
  styleUrl: './edit-addresses.component.scss',
  animations: [animationSlideInOut],
  encapsulation: ViewEncapsulation.None
})
export class EditAddressesComponent extends BaseComponent implements OnInit {
  editAddressesOptions = new EditAddressesOptions();
  @HostBinding('@slideInOut') animationState = 'open';
  addressDetail: any = {};

  constructor(injector: Injector, public dialogRef: DialogRef<EditAddressesComponent>, @Inject(DIALOG_DATA) public data: any) {
    super(injector);
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  onAddressDetailReceived(addressDetail: any) {
    this.addressDetail = addressDetail;
    if (!this.data.UserAddressId) {
      this.data.Title = addressDetail.Name;
      this.data.Address = addressDetail.Address.Road;
      this.data.Detail = addressDetail.DisplayName;
      this.data.PostalCode = addressDetail.Address.Postcode;
    }
  }

  noAction() {
    this.animationState = 'closed';
    setTimeout(() => {
      this.dialogRef.close();
    }, 500);
  }

  onSubmitClicked() {
    (this.data.UserAddressId ? this.serviceApi.updateUserAddresses(this.data.UserAddressId, {
      Latitude: this.data.Latitude,
      Longitude: this.data.Longitude,
      Title: this.data.Title,
      Address: this.data.Address,
      Detail: this.data.Detail,
      PostalCode: this.data.PostalCode,
      Phone: this.data.Phone,
      RecipientFullName: this.data.RecipientFullName,
      Details: this.addressDetail
    }) : this.serviceApi.createUserAddresses({
      UserId: this.data.UserId,
      Latitude: this.data.Latitude,
      Longitude: this.data.Longitude,
      Title: this.data.Title,
      Address: this.data.Address,
      Detail: this.data.Detail,
      PostalCode: this.data.PostalCode,
      Phone: this.data.Phone,
      RecipientFullName: this.data.RecipientFullName,
      Details: this.addressDetail
    })).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        this.noAction();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }
}
